var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 33,
    viewBox: "0 0 38 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 33H33.25C35.8699 33 38 30.8859 38 28.2857V9.42857C38 6.82835 35.8699 4.71429 33.25 4.71429H22.1543C20.8926 4.71429 19.6828 4.22076 18.7922 3.33683L16.8254 1.37746C15.9348 0.493527 14.725 0 13.4633 0H4.75C2.13008 0 0 2.11406 0 4.71429V28.2857C0 30.8859 2.13008 33 4.75 33Z",
    fill: "url(#paint0_linear_5_1131)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_1131",
    x1: 110.381,
    y1: 83.3919,
    x2: 1.07921,
    y2: 3.86804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0688A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.93b6edd4b0eb57660e9014f71275e2d2.svg";
export { ForwardRef as ReactComponent };